export default __webpack_public_path__ + "static/media/philanemo_mushroom.4f912935.png";